import { css } from 'styled-components';

import { BASE_COLORS } from './constants';

export const getThemeVariables = css`
	--white: ${BASE_COLORS.white};
	--black: ${BASE_COLORS.black};

	--green: ${BASE_COLORS.green};
	--greenLight: ${BASE_COLORS.greenLight};
	--greenUltraLight: ${BASE_COLORS.greenUltraLight};

	--gray: ${BASE_COLORS.gray};
	--grayLight: ${BASE_COLORS.grayLight};
	--grayUltraLight: ${BASE_COLORS.grayUltraLight};

	--blue: ${BASE_COLORS.blue};
	--blueLight: ${BASE_COLORS.blueLight};

	--red: ${BASE_COLORS.red};
	--redLight: ${BASE_COLORS.redLight};
	--redUltraLight: ${BASE_COLORS.redUltraLight};

	--orange: ${BASE_COLORS.orange};
	--orangeLight: ${BASE_COLORS.orangeLight};
`;
